module.exports = __webpack_public_path__ + "static/media/mobile-check-teal.a413e853.svg";